var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c("w-radio", {
        attrs: {
          name: _vm.name,
          checked: _vm.noneSelected,
          label: _vm.$ct("dont-print-after-send"),
        },
        on: {
          input: function ($event) {
            return _vm.selectNone()
          },
        },
      }),
      _c("w-radio", {
        attrs: {
          name: _vm.name,
          checked: _vm.printAfterSendSelected,
          label: _vm.$ct("print-after-send"),
        },
        on: {
          input: function ($event) {
            return _vm.selectPrintAfterSend()
          },
        },
      }),
      _c("w-radio", {
        attrs: {
          name: _vm.name,
          checked: _vm.sendAfterPrintSelected,
          label: _vm.$ct("send-after-print"),
        },
        on: {
          input: function ($event) {
            return _vm.selectSendAfterPrint()
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }